import React from "react"
import { Spinner } from "react-bootstrap"
import deleteddataApp from "../Shared/Controller/deleteddataApp"
import { RestoreImg, DeleteImg } from "../common/ImageConstants";
import { Link } from "react-router-dom";
import * as Constants from "../partials/CommonConstant";
import ConfirmModal from "../common/ConfirmModal";
import NotFound from "../common/NotFound";
import DataTable from "react-data-table-component";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";

class DeletedQuestions extends deleteddataApp {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      questionList: [],
      showDeleteModal: false,
      showRestoreModal: false,
      questionId: "",
    }
  }
  componentDidMount = () => {
    this.getQuestions();
  }

  getColumnData = (data) => {
    let columnData = "";
    if (data.type === "action") {
      return (
        <div className="edit-icon text-center">
          <Link to="/" className="ms-2" onClick={(e) => this.onClickQuestionRestore(e, data.item.id)}>
            <img src={RestoreImg} alt="Restore" title="Restore" />
          </Link>
          <Link to="/" className="ms-2" onClick={(e) => this.onClickPermenantDeleteQuestion(e, data.item.id)}>
            <img src={DeleteImg} alt="Permenant Delete" title="Permenant Delete" />
          </Link>
        </div>
      );
    }
    if (data.type === "category") {
      return (
          <>
              {data.item.category === 1 ? "File" : (data.item.category === 2 ? "Loan" : "Delinquency")}
          </>
      );
  }
    return columnData;
  }

  getCategoryText = (value) => {
    if (value === 1) {
      return "File";
    }
    if (value === 2) {
      return "Loan";
    }
    if (value === 3) {
      return "Delinquency";
    }
  }

  shortCategory = (rowA, rowB) => {
    const a = this.getCategoryText(rowA.category);
    const b = this.getCategoryText(rowB.category);

    if (a > b) {
      return 1;
    }
    if (b > a) {
      return -1;
    }
    return 0;
  };

  render() {
    // Create table headers
    const data = this.state.questionList;

    const columns = [
      {
        name: "Question",
        selector: row => row.question,
        sortable: true
      },
      {
        name: "Export Heading",
        selector: row => row.export_heading,
        sortable: true,
      },
      {
        name: "Category",
        selector: row => row.category,
        sortable: true,
        sortFunction: this.shortCategory,
        cell: d => { return this.getColumnData({ type: "category", item: d }) }

      },
      {
        name: "Action",
        center: true,
        cell: d => { return this.getColumnData({ type: "action", item: d }) }
      }
    ];

    const tableData = {
      columns,
      data
    };
    return (
      <>
        <div className="dashboard-card-wrapper deleted-page-data">
          <ConfirmModal show={this.state.showDeleteModal} type="permanentDelete"
            onCloseModal={() => this.onDeleteCloseModal()}
            module="question"
            confirmClick={(e) => this.handlePermanentDelete(e, 'Question')} />
          <ConfirmModal show={this.state.showRestoreModal} type="restore"
            onCloseModal={() => this.onRestoreCloseModal()}
            module="question"
            confirmClick={(e) => this.handleRestore(e, 'Question')} />
          <div className="row align-items-center">
            <div className="col-12 text-end">
              <Link to={Constants.templates} className="btn btn-blue btn-nex">Active Templates</Link>
            </div>
          </div>
          <div className="col-md-12 col-sm-12 col-lg-12 mt-3">
            <div className="card-main p-0">
              <div className="dark-table-wrapper table-scroll data-table">
                {this.state.questionList && this.state.questionList.length !== 0 && this.state.loading === false &&
                  <DataTableExtensions {...tableData} print={false} export={false} filterPlaceholder="Search">
                    <DataTable
                      columns={columns}
                      data={data}
                      noHeader
                      defaultSortField="name"
                      defaultSortAsc={true}
                      pagination
                      highlightOnHover
                    />
                  </DataTableExtensions>
                }
                {this.state.loading === true &&
                  <table className="mb-0 table">
                    <tbody>
                      <tr>
                        <td colSpan={10} className="text-center">
                          <Spinner animation="border" role="status">
                            <span className="visually-hidden">Loading...</span>
                          </Spinner>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                }

                {/* Not found */}
                {this.state.loading === false && this.state.questionList && this.state.questionList.length === 0 &&
                  <NotFound message="No Data Found" type="content" />
                }
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }
}
export default DeletedQuestions